module.exports = __webpack_public_path__ + "images/profile-producer.png?578c1";